module.exports = file => () => import('@/module-' + file + '.vue')



// WEBPACK FOOTER //
// ./src/router/import_production.js